export default () => {};

export const asyncNoop = async () => {};
